/**
 *
 */
export { Video as VideoPopup } from './components/Video'
export { Image as ImagePopup } from './components/Image'
